import React, { useState } from 'react';
import Content from '../../../layout/content/Content';
import Head from '../../../layout/head/Head';
import { Block, BlockHead, BlockHeadContent, BlockTitle } from '../../../components/Component';
import ProductsAnalyticalData from './data/ProductsAnalyticalData';
import CardTabs from '../../components/cards/CardTabs';
import OrderAnalyticsData from './data/OrderAnalyticsData';
import WarehouseInventoryAnalyticsData from './data/WarehouseInventoryAnalyticsData';

const AnalyticsManagement = ({ tenant_info, user_info }) => {

 const [activeCardTab, setActiveCardTab] = useState("Products");

 // Card Tabs
 const tabs = [
  {
   tabName: "Products"
  },
  {
   tabName: "Orders"
  },
  {
   tabName: "Inventory"
  }
 ];

 return (
  <>
   <Head title={tenant_info?.name ? `${tenant_info.name} Analytics` : "Analytics"} />
   <Content>
    <BlockHead size="sm">
     <BlockHeadContent>
      <BlockTitle page>Analytics</BlockTitle>
     </BlockHeadContent>
    </BlockHead>
    <Block>
     <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
    </Block>
    {
     activeCardTab === "Products" && (
      <ProductsAnalyticalData tenant_info={tenant_info} user_info={user_info} />
     )
    }
    {
     activeCardTab === "Orders" && (
      <OrderAnalyticsData tenant_info={tenant_info} user_info={user_info} />
     )
    }
    {
     activeCardTab === "Inventory" && (
      <WarehouseInventoryAnalyticsData tenant_info={tenant_info} user_info={user_info} />
     )
    }


   </Content>
  </>
 );
};

export default AnalyticsManagement;